<section class="footer" fxLayout="row" fxLayoutAlign="space-between end">
    <div *ngIf="partnerData$ | async as partner; else waitingLogoPartner"class="partners" fxLayout="column">
        <img *ngIf="partner.imagen" [src]="partner.imagen" alt="Partner logo" width="250px" height="auto">
        <a href="#"><img [src]="logoReale" alt="Ingood reale logo" width="200px" height="auto"></a>
    </div>

    <ng-template #waitingLogoPartner>
        <div>
            <a href="#"><img class="partner" [src]="logoReale" alt="Ingood reale logo" width="180px" height="auto"></a>
        </div>
      </ng-template>

    <div class="copyright">
        <p>{{translateKey + '.ingood' | translate}} &#169; {{currentYear}}.</p>
        <ul class="privacy-list" fxLayout="row">
            <li><a href="https://ingood.es/terminos-legales" target="_blank">{{translateKey + '.terms' | translate}}</a></li>
            <li><a href="https://ingood.es/terminos-legales#tabproteccion-de-datos-personales" target="_blank">{{translateKey + '.privacy' | translate}}</a></li>
            <li><a href="https://ingood.es/terminos-legales#tabpolitica-de-cookies" target="_blank">{{translateKey + '.cookies' | translate}}</a></li>
        </ul>
    </div>
</section>